import React, {Component} from 'react';
import { withScriptjs, withGoogleMap, GoogleMap, Marker } from "react-google-maps"

class MapContainer extends Component {

    constructor(props, context) {
        super(props, context);

    }


    createReactMap()
    {


        const MapWithAMarker = withScriptjs(withGoogleMap(props =>
            <GoogleMap
                defaultZoom={18}
                defaultCenter={{ lat: 39.866126, lng: 32.700520 }}
            >
                <Marker
                    position={{ lat: 39.866126, lng: 32.700520 }}
                />

            </GoogleMap>
        ));

        return(
            <MapWithAMarker
                googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyDAK3L6jAZRvGIy_Ms0sh-gqAb1ebPSTSQ&v=3.exp&libraries=geometry,drawing,places"
                loadingElement={<div style={{ height: `100%` }} />}
                containerElement={<div style={{ height: `400px` }} />}
                mapElement={<div style={{ height: `100%` }} />}
            />
        );
    }

    render() {
        return (

            <div className="template-content-section template-padding-top-reset template-padding-bottom-reset">
                {this.createReactMap()}
                {/*<div className="template-component-google-map">*/}
                {/*    /!*{this.createReactMap()}*!/*/}
                {/*</div>*/}

            </div>
        );
    }
}

export default MapContainer;
